import { DTOError } from 'src/error/errors/DTOError';
import type { JointOrder } from './types';

export const jointOrderDTO = (data: unknown): JointOrder => {
  if (!data || typeof data !== 'object') {
    throw new DTOError('jointOrderDTO', data);
  }

  return {
    ordersAmount:
      'ordersAmount' in data && typeof data.ordersAmount === 'number'
        ? data.ordersAmount
        : 0,
    firstOrderNumber:
      'firstOrderNumber' in data && typeof data.firstOrderNumber === 'number'
        ? data.firstOrderNumber
        : 0,
    isFirstOrder:
      'isFirstOrder' in data && typeof data.isFirstOrder === 'boolean'
        ? data.isFirstOrder
        : null,
  };
};
